@if (showVirtualBanner()) {
    <div class="virtual-Img-container" [ngClass]="{ pointer: !targetTab?.interstitialBanners?.ctaButtonLabel }">
        <img
            class="virtual-banner-img"
            [attr.src]="selectedVirtualBanner?.imgUrl"
            (click)="onBannerClick(selectedVirtualBanner, targetTab)"
            [attr.fetchpriority]="selectedVirtualBanner?.fetchpriority"
            [alt]="selectedVirtualBanner?.altText" />

        <div class="btn-wrapper">
            @if (targetTab?.interstitialBanners?.ctaButtonLabel) {
                <button class="btn" (click)="onCtaButtonClick(selectedVirtualBanner, targetTab)">
                    {{ targetTab?.interstitialBanners?.ctaButtonLabel }}
                </button>
            }
        </div>
    </div>
}
